<div class="pro-header" [ngClass]="{ 'printing': isPrinting() }">
  <app-product-nav></app-product-nav>
  <div class="pro-options">
    @if(currentProduct() == "peer-comparison"){
      <app-peer-selector id="tour-balance-peer" [type]="peerSelectorType()"></app-peer-selector>
    }
    <div class="pro-options__range">
      @if (dateSelectorType() == DateSelectorType.dateRange) {
        <app-date-range-selector [currentProduct]="currentProduct()" id="tour-balance-date"></app-date-range-selector>
        } @else {
        <app-date-selector id="tour-balance-date"></app-date-selector>
        }
    </div>
    <div class="pro-options__actions">
      @if (print()) {
      <a id="tour-print" class="pro-options__actions-btn" (click)="onPrint()">
        <svg class="icon pro-options__actions-icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" /></svg>
        Print
      </a>
      }
      @if (feedback()) {
      <a id="tour-feedback" class="pro-options__actions-btn" (click)="onFeedback()">
        <svg class="icon pro-options__actions-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 31.1c-141.4 0-255.1 93.13-255.1 208c0 49.62 21.35 94.98 56.97 130.7c-12.5 50.38-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734c1.25 3 4.021 4.766 7.271 4.766c66.25 0 115.1-31.76 140.6-51.39c32.63 12.25 69.02 19.39 107.4 19.39c141.4 0 255.1-93.13 255.1-207.1S397.4 31.1 256 31.1zM264 320h-112C138.8 320 128 309.3 128 296S138.8 272 152 272h112C277.3 272 288 282.8 288 296S277.3 320 264 320zM360 224h-208C138.8 224 128 213.3 128 200S138.8 176 152 176h208C373.3 176 384 186.8 384 200S373.3 224 360 224z" /></svg>
        Feedback
      </a>
      }
    </div>
  </div>
</div>
<app-room-nav [ngClass]="{ 'printing': isPrinting() }"></app-room-nav>

<div #dialog></div>

